import { IconButton } from "@ameelio/ui";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import { Box, Card, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MeetingItemData } from "../types";
import MeetingItemForm from "./MeetingItemForm";

export default function MeetingItemCard({
  item,
  isEditing,
  actionsEnabled,
  existingNames,
  onEdit,
  onCancel,
  onSave,
  onRemove,
}: {
  item: MeetingItemData | null;
  isEditing: boolean;
  actionsEnabled: boolean;
  existingNames: string[];
  onEdit: () => void;
  onCancel: () => void;
  onSave: (item: MeetingItemData) => void;
  onRemove: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      <Card
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          py: 3,
          px: 4,
          my: 2,
        }}
        variant="outlined"
      >
        {isEditing ? (
          <MeetingItemForm
            item={item}
            existingNames={existingNames}
            onCancel={onCancel}
            onSave={onSave}
            onRemove={onRemove}
          />
        ) : (
          <Stack
            direction="row"
            spacing={1}
            sx={{
              flex: 1,
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                variant="body1"
                sx={{
                  color: "text.primary",
                }}
              >
                {item?.name}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                }}
              >
                {item?.description ?? t("Reason: not given")}
              </Typography>
            </Box>
            <Stack direction="row" spacing={1}>
              <IconButton
                onClick={onEdit}
                disabled={!actionsEnabled}
                ariaLabel={t("Edit")}
                tooltip
              >
                <Edit />
              </IconButton>
              <IconButton
                onClick={onRemove}
                disabled={!actionsEnabled}
                ariaLabel={t("Remove")}
                tooltip
              >
                <Delete />
              </IconButton>
            </Stack>
          </Stack>
        )}
      </Card>
    </Stack>
  );
}
